/* eslint-disable */
import React from 'react';
import { Row, Col, Container } from 'reactstrap';

const BannerComponent = () => {
    return (
        <div>
            <div className="static-slider10">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6" className="align-self-center text-center">
                            <h1 className="title">Convext</h1>
                            <h6 className="font-16 text-white"><b>Instant conversion to text with Convext, don't worry about typing.</b></h6>
                            {/* <Link className="btn btn-outline-light btn-rounded btn-md btn-arrow m-t-20" data-toggle="collapse" to="/features" component={Features}><span> Start Now <i className="ti-arrow-right"></i></span></Link> */}
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default BannerComponent;
